import { render, staticRenderFns } from "./MaterialNew.vue?vue&type=template&id=66897a48&scoped=true&"
import script from "./MaterialNew.vue?vue&type=script&lang=ts&"
export * from "./MaterialNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66897a48",
  null
  
)

export default component.exports